<div>
  <dx-button
    id="cartButton"
    [disabled]="loading || (!itemsInCart && !itemsInCartC2)"
    stylingMode="text"
    icon="carts"
    (onClick)="toggleCart()"
  ></dx-button>
  <span
    *ngIf="!loading && itemsInCart"
    class="badge badge-success badge-cart"
    >{{ itemsInCart }}</span
  >
  <span
    *ngIf="!loading && itemsInCart && itemsInCartC2"
    class="badge badge-warning badge-cart-c2"
    >{{ itemsInCartC2 }}</span
  >
  <span
    *ngIf="!loading && !itemsInCart && itemsInCartC2"
    class="badge badge-warning badge-cart"
    >{{ itemsInCartC2 }}</span
  >
  <dx-load-indicator
    *ngIf="loading"
    height="12"
    width="12"
    class="badge-loading"
  ></dx-load-indicator>
</div>
